import React from 'react';

import { Box, Card, Typography } from 'vindi-ds-components';

import EmptyState from '@templates/empty_state';

const EmptyStateBills = () => (
  <Card
    css={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '3.5em',
      width: '100%',
      height: '100%',
      borderRadius: 'small',
      boxShadow: 'level1',
    }}
  >
    <EmptyState>
      <EmptyState.Headline>
        <Box display='flex' flexDirection='column' sx={{ gap: '8px' }}>
          <Typography variant='subtitle1'>
            Nenhuma fatura encontrada
          </Typography>
          <Typography variant='body2'>
            Quando existirem faturas, elas aparecerão aqui.
          </Typography>
        </Box>
      </EmptyState.Headline>
    </EmptyState>
  </Card>
);

export default EmptyStateBills;
